/* eslint-disable no-console */
import { preRegister } from '#src/lib/auth';
import { isRegisteredUserError } from '#src/lib/auth/selectors';
import { requireAuthentication } from '#src/lib/routes/guards';
import { selectParams } from '#src/store/location/selectors';
import {
  sessionRemoval,
  setProspectUser,
  setGeoLocation,
} from '#src/store/session/actions';
import { isProspectUser } from '#src/store/session/selectors';
import { selectTheme } from '#src/store/theme/selectors';

export const path = '/membership-signup';
export const component = 'MembershipSignup';
export const thunk =
  ({ ctx }) =>
  async (dispatch, getState) => {
    const state = getState();
    const { email } = selectParams(state);
    const product = selectTheme(state);

    console.log('membership-signup thunk: email:', email);

    // This route is designed to have an email param to indicate that a prospect
    // user should be created.
    if (!email) {
      // If no email present, require authentication for non-prospect users.
      if (isProspectUser(state)) {
        return;
      }

      console.log('membership-signup thunk: requiring auth');
      requireAuthentication(dispatch, getState);
      return;
    }

    // Email present, use it to create prospect. Clear any previous session.
    try {
      console.log('membership-signup: reset session');
      dispatch(sessionRemoval());
      const user = await preRegister({ email }, { product, ctx });
      console.log('membership-signup: preRegister user id:', user.id);
      dispatch(setProspectUser({ ...user, role: 'prospect' }));
    } catch (error) {
      console.log('membership-signup: error:', error);
      if (!isRegisteredUserError({ error })) {
        throw error;
      }

      requireAuthentication(dispatch, getState);
    }

    dispatch(setGeoLocation(ctx.state.geo || {}));
  };
